import { render, staticRenderFns } from "./MinisiteTransferConfirmation.vue?vue&type=template&id=c34c7190&scoped=true&"
import script from "./MinisiteTransferConfirmation.vue?vue&type=script&lang=js&"
export * from "./MinisiteTransferConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteTransferConfirmation.vue?vue&type=style&index=0&id=c34c7190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34c7190",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c34c7190')) {
      api.createRecord('c34c7190', component.options)
    } else {
      api.reload('c34c7190', component.options)
    }
    module.hot.accept("./MinisiteTransferConfirmation.vue?vue&type=template&id=c34c7190&scoped=true&", function () {
      api.rerender('c34c7190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MinisiteTransferConfirmation.vue"
export default component.exports